import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import appUrl from "../../appURL.json";

let signalRConnection = null;

export const initSignalRConnection = async () => {
    if (signalRConnection) return signalRConnection;

    const token = localStorage.getItem("token");
    if (!token) {
        console.warn("No token found. SignalR will not connect.");
        return null;
    }

    const connection = new HubConnectionBuilder()
        .withUrl(appUrl.API_SignalRHub, {
            accessTokenFactory: () => token,
        })
        .configureLogging(LogLevel.Information)
        .withAutomaticReconnect()
        .build();

    try {
        await connection.start();
        console.log("SignalR connected");
        signalRConnection = connection;
    } catch (error) {
        console.error("SignalR connection failed:", error);
    }

    return signalRConnection;
};
